import React, { Fragment } from 'react';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { AgentType } from '@domain-group/fe-allhomes-library';
import * as styles from './allhomes-listing-card-agency-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardAgencyDetails = _ref => {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? AgentType.Agent.name : _ref$type,
    name = _ref.name,
    logo = _ref.logo,
    logoBackground = _ref.logoBackground,
    url = _ref.url,
    _ref$agents = _ref.agents,
    agents = _ref$agents === void 0 ? [] : _ref$agents,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    inclusions = _ref.inclusions;
  var isPlatinum = (inclusions === null || inclusions === void 0 ? void 0 : inclusions.brandingLevel) === 'PLATINUM';
  var isPrivateLister = type === AgentType.PrivateLister.name;
  var renderLogo = () => ___EmotionJSX("img", {
    css: styles.logo(isPlatinum),
    src: logo !== null && logo !== void 0 ? logo : undefined,
    alt: name !== null && name !== void 0 ? name : undefined
  });
  var renderAvatar = () => {
    var _agents$, _agents$2;
    return ___EmotionJSX("div", {
      css: styles.avatarContainer
    }, ___EmotionJSX(Avatar, {
      css: styles.avatar,
      imageUrl: ((_agents$ = agents[0]) === null || _agents$ === void 0 ? void 0 : _agents$.image) || undefined,
      imageTitle: ((_agents$2 = agents[0]) === null || _agents$2 === void 0 ? void 0 : _agents$2.name) || undefined
    }));
  };
  return ___EmotionJSX("a", {
    css: styles.agencyDetails,
    href: url !== null && url !== void 0 ? url : undefined,
    onClick: evt => {
      _onClick(evt);
      evt.stopPropagation();
    }
  }, isPlatinum ? ___EmotionJSX("div", {
    css: styles.platinumLogo(logoBackground || '')
  }, renderLogo(), renderAvatar()) : ___EmotionJSX(Fragment, null, !isPrivateLister && ___EmotionJSX("div", {
    css: styles.goldLogo
  }, renderLogo())), ___EmotionJSX("div", {
    css: styles.names(isPrivateLister)
  }, isPrivateLister ? 'Private lister' : agents.map(agent => agent === null || agent === void 0 ? void 0 : agent.name).join(' & ') || name));
};
export { AllhomesListingCardAgencyDetails };